module.exports = __webpack_public_path__ + "static/media/blog-4.bcdd1485.jpg";